import { CHAT_TYPE, CS_TAB } from '@/types/cs';
import { createSlice } from '@reduxjs/toolkit';

type CsType = {
  isOpenCsModal: boolean;
  isOpenChat: boolean;
  isOpenAlert: boolean;
  chatId: number | null;
  hasOpenChatAnimation: boolean;
  chatType: CHAT_TYPE;
  activeTab: CS_TAB;
  isHiddenInquiryButtons: boolean;
};

const initialState: CsType = {
  isOpenCsModal: false,
  isOpenChat: false,
  isOpenAlert: false,
  chatId: null,
  hasOpenChatAnimation: false,
  chatType: 'CHAT',
  activeTab: 'HOME',
  isHiddenInquiryButtons: false,
};

const csSlice = createSlice({
  name: 'cs',
  initialState,
  reducers: {
    updateCs: (state, action) => {
      return { ...state, ...action.payload };
    },
    closeCsModal: (state) => {
      return {
        ...initialState,
      };
    },
    closeChat: (state) => {
      return {
        ...state,
        isOpenChat: false,
        chatId: null,
        hasOpenChatAnimation: false,
        chatType: 'CHAT',
        isHiddenInquiryButtons: false,
      };
    },
  },
});

export const { updateCs, closeCsModal, closeChat } = csSlice.actions;
export default csSlice.reducer;
